var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFilterAltFilled = function SvgFilterAltFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "m14.5 13.5 5.207-5.207A1 1 0 0 0 20 7.586V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2.586c0 .265.105.52.293.707L9.5 13.5M9.5 13.5v6.249c0 .813.764 1.41 1.553 1.213l2.5-.625a1.25 1.25 0 0 0 .947-1.213V13.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m14.5 13.5 5.207-5.207A1 1 0 0 0 20 7.586V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2.586c0 .265.105.52.293.707L9.5 13.5v6.249c0 .813.764 1.41 1.553 1.213l2.5-.625a1.25 1.25 0 0 0 .947-1.213V13.5Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFilterAltFilled);
export default ForwardRef;